import React, { useState, useRef, useEffect } from "react"
import ClassNames from "classnames"
import { Link } from "react-router-dom"
import { includes, get, map, split, size, findIndex } from "lodash"

import { Route } from "components/organisms/links/mainMenu"
import { checkIsSp } from "utils/util"
import store from "redux/store"
import { cancelLoad, pageLoad } from "redux/ducks/PageLoad"
import { useChangeMenuTrigger } from "../../actions/customHook/changeMenu"

export const FooterNav = (props: { route: Array<Route>; path: string }) => {
  const { _changeMenuTrigger } = useChangeMenuTrigger()
  return (
    <ul className="foot-border-tabs nav-tabs">
      {props.route.map((row, i: number) => (
        <li
          key={i}
          className={ClassNames("nav-home", {
            active: includes(props.path, row.path),
          })}
          onClick={() => _changeMenuTrigger.setChangeMenuFlag(true)}
        >
          <Link to={row.path} onClick={() => store.dispatch(cancelLoad())}>
            <i className="material-icons">{row.icon}</i>
            <span className="footer-nav-title">{row.name}</span>
          </Link>
        </li>
      ))}
    </ul>
  )
}

type RouteType = {
  path: string
  name: string
}

export const SubNav: React.FC<PropsType> = (props: PropsType) => {
  const subNavWrapper = useRef(null)
  const subNavContainer = useRef(null)
  const [navigationPosition, changePosition] = useState<number>(0)
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timer>(null)

  //sp swipe function
  const [swipePoint, setSwipe] = useState<number>(0)
  const [swipeValue, changeSwipeValue] = useState<number>(0)

  const prevPosition = useRef(navigationPosition)
  const isHeadNext = useRef<boolean>()
  const prevPath = useRef<string>(splitParentPathName(props.pathname))
  const isPhone = checkIsSp()
  const clearTimer = () => {
    prevPosition.current = navigationPosition
    clearTimeout(timeoutId)
  }
  useEffect(() => {
    clearTimer()
    const parentPath = splitParentPathName(props.pathname)
    if (parentPath !== prevPath.current) {
      prevPosition.current = 0
      changePosition(0)
      prevPath.current = parentPath
    } else {
      const selectedContent = findIndex(props.route, { path: props.pathname })
      prevPosition.current = selectedContent
      changePosition(selectedContent)
    }
  }, [props.pathname])
  const subNavContainerWidth =
    get(subNavContainer, "current.offsetWidth", 0) + 20
  const subNavWrapperWidth = get(subNavWrapper, "current.offsetWidth", 0)
  const subNavPadding = (props.windowWidth - subNavWrapperWidth) / 4
  const marginWidth = subNavContainerWidth - subNavWrapperWidth - subNavPadding

  const isOverSize = marginWidth > 0
  const navItem: HTMLDivElement | null = get(
    document.getElementsByClassName("sub-nav-tab active"),
    "0",
    null
  )

  const navItemWidth = get(navItem, "offsetWidth", 0)
  const currentPosition = -navItemWidth * navigationPosition
  const position =
    -marginWidth > currentPosition ? -marginWidth : currentPosition
  const maxNavigationPosition = Math.floor(marginWidth / navItemWidth) + 1
  const _setNewNavPosition = (isForward: boolean) => {
    const newNav = navigationPosition + (isForward ? 1 : -1)
    if (newNav < 0 || maxNavigationPosition < newNav) return
    changePosition(newNav)
    isHeadNext.current = isForward
  }
  useEffect(() => {
    if (prevPosition.current === navigationPosition) return
    clearTimeout(timeoutId)
    setTimeoutId(
      setTimeout(() => {
        _setNewNavPosition(isHeadNext.current)
      }, 500)
    )
  }, [navigationPosition])

  useEffect(() => {
    if (!swipePoint && !!swipeValue) {
      const isOver = swipeValue % -navItemWidth > -navItemWidth / 2
      const moveItem =
        Math.floor(swipeValue / -navItemWidth) +
        (isOver ? (-swipeValue > 0 ? 1 : -1) : 0)
      const newPosition = navigationPosition + moveItem

      if (newPosition <= 0) {
        prevPosition.current = 0
        changePosition(0)
      } else if (newPosition >= maxNavigationPosition) {
        prevPosition.current = maxNavigationPosition
        changePosition(maxNavigationPosition)
      } else {
        prevPosition.current = newPosition
        changePosition(newPosition)
      }
      changeSwipeValue(0)
    }
  }, [swipePoint])

  const navStartPosition = () => {
    if (isOverSize) {
      if (!!swipeValue) {
        const swipePosition = position + swipeValue
        if (swipePosition > 0) {
          return 0
        } else if (-subNavContainerWidth + subNavWrapperWidth > swipePosition) {
          return -subNavContainerWidth + subNavWrapperWidth
        } else {
          return swipePosition
        }
      } else {
        return position
      }
    } else {
      return 0
    }
  }
  return (
    <div
      className="sub-nav"
      onTouchStart={e => setSwipe(e.touches[0].pageX)}
      onTouchMove={e =>
        changeSwipeValue(e.changedTouches[0].pageX - swipePoint)
      }
      onTouchEnd={() => setSwipe(0)}
    >
      <div className="sub-nav-wrapper" ref={subNavWrapper}>
        <div
          className="sub-nav-container"
          ref={subNavContainer}
          style={{ left: navStartPosition() }}
        >
          {props.route !== undefined
            ? map(props.route, (row: RouteType, key: number) => {
                const isAnotherPage = row.path.includes("http")
                return isAnotherPage ? (
                  <a
                    key={key}
                    className={ClassNames("sub-nav-tab", {
                      disabled: row.path === props.pathname,
                    })}
                    href={row.path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {row.name}
                  </a>
                ) : (
                  <Link
                    key={key}
                    className={ClassNames("sub-nav-tab", {
                      active: row.path === props.pathname,
                      disabled: row.path === props.pathname,
                    })}
                    to={row.path}
                    onClick={() => {
                      store.dispatch(cancelLoad())
                    }}
                  >
                    {row.name}
                  </Link>
                )
              })
            : null}
        </div>
      </div>
      {isOverSize && !!size(props.route) ? (
        <>
          <div
            className={ClassNames("sub-nav-prev", {
              disabled: navigationPosition === 0,
            })}
          >
            <i
              className="material-icons"
              onClick={e => {
                e.stopPropagation()
                if (!isPhone) {
                  prevPosition.current = 0
                  changePosition(0)
                }
              }}
              onTouchStart={() => _setNewNavPosition(false)}
              onTouchEnd={() => clearTimer()}
            >
              chevron_left
            </i>
          </div>
          <div
            className={ClassNames("sub-nav-next", {
              disabled:
                navigationPosition === maxNavigationPosition ||
                navStartPosition() === -marginWidth,
            })}
          >
            <i
              className="material-icons"
              onClick={e => {
                e.stopPropagation()
                if (!isPhone) {
                  prevPosition.current = maxNavigationPosition
                  changePosition(maxNavigationPosition)
                }
              }}
              onTouchStart={() => _setNewNavPosition(true)}
              onTouchEnd={() => clearTimer()}
            >
              chevron_right
            </i>
          </div>
        </>
      ) : null}
    </div>
  )
}
type PropsType = {
  route: Array<RouteType> | [] | undefined
  pathname: string
  windowWidth: number
}

const splitParentPathName = (path: string) => {
  return split(path, "/", 2)[1]
}
